import { PostalCodeMapper } from './PostalCodeMapper.js';

class PostalCodesRepository {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  all(params) {
    return this.apiClient.get('v1/locations/postalcodes', {
      ...params,
      ...this.apiClient.withRequestContext()
    }).then(response => response.data.map(PostalCodeMapper.createModelFromResponse));
  }
  allByAlpha2Code(alpha2Code, params) {
    return this.apiClient.get(`v1/locations/postalcodes/country/${alpha2Code}`, {
      ...params,
      ...this.apiClient.withRequestContext()
    }).then(response => response.data.map(PostalCodeMapper.createModelFromResponse));
  }
  getPostalCodeCoordinates(zipCode, city) {
    const {
      platform,
      platform_country
    } = this.apiClient.withRequestContext();
    return this.apiClient.get(`v1/locations/postalcodes/${platform_country}/${zipCode}`, {
      params: {
        platform,
        platform_country
      }
    }).then(postalCodes => {
      const postalCode = postalCodes.data.filter(pc => {
        return pc.city.name.toUpperCase() === city.toUpperCase();
      })[0];
      if (!postalCode) {
        throw new Error('No postal code found for the given alpha code and city.');
      }
      return {
        id: postalCode.id,
        lat: parseFloat(postalCode.latitude),
        lng: parseFloat(postalCode.longitude)
      };
    });
  }
}

export { PostalCodesRepository };
//# sourceMappingURL=PostalCodesRepository.js.map
